import logo from "../images/logo.svg"
import { navLink } from "./Data"

function Navbar() {
  return (
    <nav className='navbar'>
      <div className='nav-center'>
        <div className='nav-header'>
          <img src={logo} className='nav-logo' alt='W. News' />
          <ul className='nav-links' id='nav-links'>
            {navLink.map((link) => {
              return (
                <li key={link.id}>
                  <a href={link.href} className='nav-link'>
                    {link.text}
                  </a>
                </li>
              )
            })}
          </ul>
          <button type='button' className='nav-toggle' id='nav-toggle'></button>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
